export default __webpack_public_path__ + "images/fd8a20c839fbf4face16ae50763de96b.svg";